import React from 'react';

const IconCheckboxUnchecked = (props) => (
  <svg viewBox="0 0 24 24" {...props}>
    <rect x="3" y="3" width="18" height="18" rx="2" fill={props.color} />
  </svg>
);

export default IconCheckboxUnchecked;
